import { ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { BottomNavigation } from "./BottomNavigation";

interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const location = useLocation();
  const isHome = location.pathname === "/";
  const isProfilo = location.pathname === "/profilo";
  const isConcierge = location.pathname === "/concierge";

  const getMainStyle = () => {
    if (isHome || isProfilo || isConcierge) return undefined;
    return { paddingBottom: 'calc(var(--safe-area-bottom, 0px) + 96px)' };
  };

  return (
    <div 
      className={isHome ? "bg-background overflow-hidden" : "min-h-screen bg-background"}
      style={isHome ? { height: '100dvh' } : undefined}
    >
      <main style={getMainStyle()}>
        {children}
      </main>
      {!isConcierge && <BottomNavigation />}
    </div>
  );
}
